const BROWSER_CONFIG = [
    {
      value: "chrome_desktop",
      label: "Google Chrome (Desktop)",
      instructions: "Open Chrome → Menu → Bookmarks and lists → Bookmark Manager → ⋮ → Export Bookmarks."
    },
    {
      value: "firefox_desktop",
      label: "Mozilla Firefox (Desktop)",
      instructions: "Open Firefox → Bookmarks → Manage Bookmarks → Select All Bookmarks → ↑↓ (Import and Backup button) → Export Bookmarks to HTML."
    },
    {
      value: "edge_desktop",
      label: "Microsoft Edge (Desktop)",
      instructions: "Open Edge → ⋯ → Favorites → ⋮ → Export Favorites."
    },
    {
      value: "safari_desktop",
      label: "Apple Safari (Desktop)",
      instructions: "Open Safari → File → Export Browsing Data To File... → Select Bookmarks → Export → Unzip the downloaded file."
    },
    {
      value: "mobile_safari_mobile",
      label: "Apple Safari (Mobile)",
      instructions: "Open Settings app → Tap Apps → Tap Safari → Below History and Website Data, tap Export → Select Bookmarks → Tap Save to Downloads → Unzip the downloaded file."
    },
    {
      value: "mobile_chrome_mobile",
      label: "Google Chrome (Mobile)",
      instructions: 'We recommend saving mobile bookmarks to your google account and then exporting from your desktop. Follow the <a href="https://support.google.com/chrome/answer/165139?hl=en&co=GENIE.Platform%3DAndroid&oco=0">official guides</a>.'
    },
    {
      value: "brave_mobile",
      label: "Brave (Mobile)",
      instructions: 'Follow the official guide <a href="https://support.brave.app/hc/en-us/articles/360057082371-How-do-I-Import-or-Export-Bookmarks-on-iOS">for iOS</a> or <a href="https://support.brave.app/hc/en-us/articles/35780681703053-How-do-I-import-or-export-data-in-Brave-Android">Android</a>'
    }
]

export default BROWSER_CONFIG;
